// extracted by css-extract-rspack-plugin
export default {"header":"wZBe9IUB4eUjswau"};